import React from "react"
import cx from "classnames"

export interface BasicCellProps {
  children: React.ReactNode
  leftAddonIcon?: React.ReactNode
  leftAddonThumbUrl?: string
  leftAddonThumbAlt?: string
  leftAddonThumbSquare?: boolean
  title: string
  rightAddonIcon?: React.ReactNode
  large?: boolean
}

export const BasicCell = ({
  leftAddonIcon,
  leftAddonThumbUrl,
  leftAddonThumbAlt,
  leftAddonThumbSquare,
  title,
  children,
  rightAddonIcon,
  large = false,
}: BasicCellProps) => {
  let leftAddon: React.ReactNode | BasicCellProps["leftAddonIcon"] | null = null

  if (leftAddonIcon != null) leftAddon = leftAddonIcon
  else if (leftAddonThumbUrl != null) {
    const leftAddonThumbSize = large ? 64 : 44
    leftAddon = (
      <div
        className={cx("cobalt-BasicCell__Thumb", {
          "cobalt-BasicCell__Thumb--square": leftAddonThumbSquare,
        })}
      >
        <img
          src={leftAddonThumbUrl}
          alt={leftAddonThumbAlt}
          width={leftAddonThumbSize}
          height={leftAddonThumbSize}
        />
      </div>
    )
  }

  return (
    <div
      className={cx("cobalt-BasicCell", {
        "cobalt-BasicCell--large": large === true,
      })}
    >
      {leftAddon != null && (
        <div className="cobalt-BasicCell__LeftAddon">{leftAddon}</div>
      )}
      <div className="cobalt-BasicCell__Main">
        <div className="cobalt-BasicCell__Title">{title}</div>
        <div className="cobalt-BasicCell__Content">{children}</div>
      </div>
      {rightAddonIcon != null && (
        <div className="cobalt-BasicCell__RightAddonIcon">{rightAddonIcon}</div>
      )}
    </div>
  )
}
